import {useEffect, useState} from "react";
import {Heading, Box} from '@chakra-ui/react';
import './strategyContent.scss';
import StrategyStepper from "../stepper/strategyStepper";
import TableData from "../tableData/tableData";
import Tags from "../tags/tags";
import {formatStrategyName} from '../../utilities/formatStrategyName';

const StrategyContent = ({strategies, selectedStrategy, stepIndex, stepsData, selectedTags, setSelectedTags}) => {
    const sectionTitle = [
        'Securities Section',
        'First Bar Section',
        'Second Bar Section',
        'Trade Section',
    ];

    const [selectedStep, setSelectedStep] = useState(0);

    useEffect(() => {
        if (typeof selectedStep === 'undefined' || selectedStep === null) return;
        // Resetta il tag quando cambia step
        const key = `${selectedStrategy}-${selectedStep}`;
        setSelectedTags(prev => ({
            ...prev,
            [key]: null
        }));
    }, [selectedStep, selectedStrategy]);

    const getTagKey = (strategyIndex, step) => `${strategyIndex}-${step}`;

    const handleTagSelection = (tag) => {
        const key = getTagKey(selectedStrategy, selectedStep);
        setSelectedTags(prev => ({
            ...prev,
            [key]: tag
        }));
    };

    const strategyName = strategies[selectedStrategy] || 'Nessuna strategia';
    const formattedStrategyName = formatStrategyName(strategyName);

    return (
        <section className="strategy-content">
            <Box className="content-header" p={4} bg="white" borderBottom="1px solid" borderColor="gray.200">
                <Heading as="h2" size="lg" color="gray.700" mb={2}>
                    {formattedStrategyName}
                </Heading>
                <StrategyStepper stepIndex={stepIndex} setSelectedStep={setSelectedStep}/>
            </Box>

            <Box className="content-body" p={4}>
                <Heading className="section-title" as='h4' size='md' mb={4} color="gray.600">
                    {sectionTitle[selectedStep]}
                </Heading>

                <section className="panel-body">
                    {stepsData[selectedStep]?.message ? (
                        <div className="message-box">
                            <Tags
                                securities={stepsData[selectedStep].message.securities}
                                setTagSelected={handleTagSelection}
                                selectedTag={selectedTags[getTagKey(selectedStrategy, selectedStep)]}
                            />
                        </div>
                    ) : ('')}

                    {stepsData[selectedStep]?.table ? (
                        <div className="table-box">
                            <TableData
                                actualStep={selectedStep}
                                data={stepsData[selectedStep].table}
                                filter={selectedTags[getTagKey(selectedStrategy, selectedStep)]}
                            />
                        </div>
                    ) : ('')}
                </section>
            </Box>
        </section>
    );
};

export default StrategyContent;
